import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

const Newsletter = () => {
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    toast.success("E-mail cadastrado! Você receberá nossas ofertas.");
    setEmail("");
  };

  return (
    <section className="bg-slate-50 border-y border-slate-200" data-testid="newsletter-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">
            Receba ofertas da Sulbel
          </h2>
          <p className="mt-3 text-slate-600">
            Cadastre seu e-mail e fique por dentro das novidades e promoções.
          </p>
          <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-xl mx-auto">
            <Input
              type="email"
              required
              data-testid="newsletter-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Digite seu melhor e-mail"
              className="h-12 flex-1 rounded-md border-slate-300 bg-white text-base"
            />
            <Button
              type="submit"
              data-testid="newsletter-submit"
              className="h-12 px-8 bg-brand hover:bg-brand-hover text-white font-semibold rounded-md active:scale-[0.98] transition-all"
            >
              Cadastrar
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
